import { FC, useState } from "react";
import Select, { Theme } from 'react-select';
import './ChatButton.css';

type valueLabel = {
  value: string;
  label: string;
}

const languages: valueLabel[] = [
  { value: "UK_Chat Czech", label: "Czech" },
  { value: 'UK_Chat Dutch', label: 'Dutch' },
  { value: 'UK_Chat English', label: 'English' },
  { value: 'UK_Chat French', label: 'French' },
  { value: 'UK_Chat German', label: 'German' },
  { value: 'UK_Chat Hungarian', label: 'Hungarian' },
  { value: 'UK_Chat Portuguese', label: 'Portuguese' },
  { value: 'UK_Chat Romanian', label: 'Romanian' },
  { value: 'UK_Chat Russian', label: 'Russian' },
  { value: 'UK_Chat Spanish', label: 'Spanish' },
];

export interface ChatButtonProps {
  defaultProfile: string,
  onLanguageSelected: (profile: string) => void
}

export const ChatButton: FC<ChatButtonProps> = ({ defaultProfile, onLanguageSelected }) => {
  const [hideFrame, setHideFrame] = useState<boolean>(true);
  const defaultLanguage = languages.find(x => x.value == defaultProfile);
  const [selectedLanguage, setSelectedLanguage] = useState<valueLabel | null>(defaultLanguage ?? null);

  return (
    <>
      <div className="language-header">
        <div className="five9-chat-button" onClick={() => setHideFrame(false)}>
          <span className="five9-icon"></span>
          <span className="five9-text">Chat</span>
        </div>
      </div>
      <div id="language-popup" className="language-global" hidden={hideFrame}>
        <div className="language-header">
          <div className="five9-chat-button">
            <div className="five9-icon"></div>
            <div className="five9-text">Chat</div>
            <div id="five9-minimize-icon" title="Click to minimize" onClick={() => setHideFrame(true)}></div>
          </div>
        </div>
        <div id="language-title">Language Selector</div>
        <div id="language-container">
          <Select
            defaultValue={selectedLanguage}
            onChange={setSelectedLanguage}
            options={languages}
            maxMenuHeight={140}
            isSearchable={false}
            theme={(theme: Theme) => ({
              ...theme,
              colors: {
                ...theme.colors,
                primary25: theme.colors.neutral10,
                primary: 'black',
              },
            })}
          />
          <button id="language-button" disabled={selectedLanguage == null}
            onClick={() => selectedLanguage && onLanguageSelected(selectedLanguage.value)}>Launch Chat</button>
        </div>
      </div>
    </>
  );
};